import type { LocaleInput } from './locale';
import { formatNumberByLocale } from './numbers';

/** What the location average boxes show for a missing, or zero, average. */
const MISSING_AVERAGE = '---';
const WOUND_DECIMALS = 1;
const LICE_DECIMALS = 2;
/** Wound rates are shown in half-percent steps. */
const WOUND_STEPS_PER_UNIT = 200;

/** Average daily growth in whole grams, rounded down. */
export function formatGrowthValue(growth: number | undefined, locale: LocaleInput): string {
    return growth
        ? formatNumberByLocale(Math.floor(growth), locale, 0, MISSING_AVERAGE)
        : MISSING_AVERAGE;
}

/** "g/day" in the given, already translated, word for day. */
export function formatGrowthUnit(daypartLocalizedText: string): string {
    return `g/${daypartLocalizedText}`;
}

/** A wound rate given as a fraction, shown in percent to the nearest half percent. */
export function formatWoundsValue(wound: number | undefined, locale: LocaleInput): string {
    if (!wound) return MISSING_AVERAGE;
    const percent = (100 * Math.round(wound * WOUND_STEPS_PER_UNIT)) / WOUND_STEPS_PER_UNIT;
    return formatNumberByLocale(percent, locale, WOUND_DECIMALS, MISSING_AVERAGE);
}

/** Average lice per fish. */
export function formatLiceValue(lice: number | undefined, locale: LocaleInput): string {
    return lice
        ? formatNumberByLocale(lice, locale, LICE_DECIMALS, MISSING_AVERAGE)
        : MISSING_AVERAGE;
}
